import {
  RESET_INSIGHTS_OBJ,
  RESET_INSIGHTS_STATUS,
  INSIGHTS_ERROR,
  SET_INSIGHTS,
  SET_INSIGHTS_SUCCESS,
} from "./actionTypes";

export const resetInsightsObj = () => {
  return {
    type: RESET_INSIGHTS_OBJ,
    payload: {},
  };
};
export const resetInsightsStatus = (reset) => {
  return {
    type: RESET_INSIGHTS_STATUS,
    payload: reset,
  };
};
export const insightsError = (error) => {
  return {
    type: INSIGHTS_ERROR,
    payload: error,
  };
};

export const setInsights = (newInsightValues) => {
  return {
    type: SET_INSIGHTS,
    payload: newInsightValues,
  };
};
export const setInsightsSuccess = (newInsightValues) => {
  return {
    type: SET_INSIGHTS_SUCCESS,
    payload: newInsightValues,
  };
};
